import type { LeasingFeatures } from '../types/LeasingFeatures';
import { phoebeFlags as AT } from './AT';
import { phoebeFlags as CZ } from './CZ';
import { phoebeFlags as HR } from './HR';
import { phoebeFlags as HU } from './HU';
import { phoebeFlags as RO } from './RO';
import { phoebeFlags as RS } from './RS';
import { phoebeFlags as SK } from './SK';

export const phoebeFlags: Record<string, LeasingFeatures> = { AT, CZ, HR, HU, RO, RS, SK };
